var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect } from 'react';
import { themeGet } from '@styled-system/theme-get';
import styled from 'styled-components';
import { Close as CloseIcon } from 'pcln-icons';
import { Absolute } from '../Absolute';
import { Flex } from '../Flex';
import { IconButton } from '../IconButton';
import { Relative } from '../Relative';
import { Text } from '../Text';
import { getPaletteColor } from '../utils';
var RoundIconButton = styled(IconButton)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background-color: ", ";\n  padding: ", ";\n\n  &:hover {\n    background-color: ", ";\n  }\n"], ["\n  background-color: ", ";\n  padding: ", ";\n\n  &:hover {\n    background-color: ", ";\n  }\n"])), getPaletteColor('background.lightest'), themeGet('space.1'), getPaletteColor('background.lightest'));
function Toast(_a) {
    var children = _a.children, _b = _a.color, color = _b === void 0 ? 'text.light' : _b, hideClose = _a.hideClose, icon = _a.icon, id = _a.id, lifespan = _a.lifespan, onRemoveClick = _a.onRemoveClick, props = __rest(_a, ["children", "color", "hideClose", "icon", "id", "lifespan", "onRemoveClick"]);
    useEffect(function () {
        var timer;
        if (lifespan > 0) {
            timer = setTimeout(function () {
                onRemoveClick(id);
            }, lifespan);
        }
        return function () { return clearTimeout(timer); };
    }, []);
    function handleRemoveClick() {
        onRemoveClick(id);
    }
    return (React.createElement(Relative, null,
        React.createElement(Flex, __assign({}, props, { borderRadius: 'lg', boxShadowSize: 'xl', color: color, justifyContent: 'space-between', alignItems: 'center', p: 3 }),
            icon && React.createElement(Flex, { mr: 3 }, icon),
            React.createElement(Flex, { width: '100%' }, typeof children === 'string' ? React.createElement(Text, { textStyle: 'paragraph' }, children) : children),
            !hideClose && (React.createElement(Absolute, { top: -12, right: -12 },
                React.createElement(RoundIconButton, { borderRadius: 'full', boxShadowSize: 'sm', icon: React.createElement(CloseIcon, { color: 'primary', size: 20, title: 'close-toast' }), onClick: handleRemoveClick }))))));
}
export default Toast;
var templateObject_1;
//# sourceMappingURL=Toast.js.map